import { GuestService } from 'src/app/services/guest/guest.service';
import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { CreditService } from 'src/app/services/subscription/credit.service';
import { AccountCoupleService } from 'src/app/services/account/account-couple.service';
import { AccountInfoService } from 'src/app/services/account/account-info.service';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ElementRef, ViewChild, HostListener } from '@angular/core';
import { AccountTaskService } from 'src/app/services/account/account-task.service';
import { NewsCardSlideType, NewsType } from 'src/app/types/news';
import { AccountTaskType } from 'src/app/types/task';

import { VoucherService } from 'src/app/services/subscription/voucher.service';
import { PrivilegeService } from 'src/app/services/account/privilege/privilege.service';
import { ModuleType } from 'src/app/types/general';
import { LocalityService } from 'src/app/services/location/locality.service';
import { AccountService } from 'src/app/services/account/account.service';
import { Subscription } from 'rxjs';
import { FunctionService } from 'src/app/services/general/function.service';
import Swiper from 'swiper';
import { Platform } from '@ionic/angular';

// SwiperCore.use([ Autoplay ]);

@Component({
  selector: 'app-news-card-slide',
  templateUrl: './news-card-slide.component.html',
  styleUrls: ['./news-card-slide.component.scss'],
})
export class NewsCardSlideComponent implements OnInit, OnDestroy {

  /**
   * Watch screen resize change
   */
  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.setupSlidePerView(true);
  }
  /**
   * Watch screen orientation change
   */
  @HostListener('window:orientationchange', ['$event']) onOrientationChange(event: any) {
    this.setupSlidePerView(true);
  }

  @ViewChild('container', { read: ElementRef, static: false }) container: ElementRef;

  @Input() set setReady(ready: boolean) {
    this.ready = ready;

    if (this.ready) {
      this.watch();
      this.setupSlidePerView();

    } else {
      this.unwatch();
    }
  }

  @Input() newsCardSlideType: NewsCardSlideType;

  @Output() clickAction = new EventEmitter<any>();

  ready: boolean;

  accountReady: boolean;

  slidePerView: number;

  newsCard: {
    [key: string]: boolean;
  };

  // private totalSlides: number;

  private privilegeSubscription: Subscription;

  private readySubscription: Subscription;

  constructor(
    private platform: Platform,
    private accountService: AccountService,
    private accountListSerivce: AccountsListService,
    private accountTaskService: AccountTaskService,
    private accountInfoService: AccountInfoService,
    private accountCoupleService: AccountCoupleService,
    private guestService: GuestService,
    private creditService: CreditService,
    private voucherService: VoucherService,
    private privilegeService: PrivilegeService,
    private localityService: LocalityService,
    private functionService: FunctionService,
  ) { }

  ngOnInit() {}

  ngOnDestroy() {
    this.unwatchPrivilege();
  }

  watch() {
    this.watchPrivilege();
    this.watchReady();
  }

  unwatch() {
    this.unwatchPrivilege();
    this.unwatchReady();
  }

  watchPrivilege() {
    if (!this.privilegeSubscription) {
      this.privilegeSubscription = this.privilegeService.observableCurrentPrivilege.subscribe(() => {
        this.setupNewsCard();
      });
    }
  }

  unwatchPrivilege() {
    if (this.privilegeSubscription) {
      this.privilegeSubscription.unsubscribe();
      this.privilegeSubscription = null;
    }
  }

  watchReady() {
    if (!this.readySubscription) {
      this.readySubscription = this.accountService.observableReady.subscribe((ready: boolean) => {
        this.accountReady = ready;
        this.setupNewsCard();
      });
    }
  }

  unwatchReady() {
    if (this.readySubscription) {
      this.readySubscription.unsubscribe();
      this.readySubscription = null;
    }
  }

  // setupSwiper(event: any) {
  //   if (event?.detail?.[0]?.slides?.length) {
  //     this.totalSlides = event?.detail?.[0]?.slides?.length;
  //   } else if (event?.target?.swiper?.slides?.length) {
  //     this.totalSlides = event?.target?.swiper?.slides?.length;
  //   } else if (event?.srcElement?.swiper?.slides?.length) {
  //     this.totalSlides = event?.srcElement?.swiper?.slides?.length;
  //   } else {
  //     this.totalSlides = 0;
  //   }
  // }

  setupNewsCard() {
    if (!this.newsCard) {
      this.newsCard = {};
    }
    this.newsCard['trial_suggestion'] = this.checkNewsCard('trial_suggestion');
    this.newsCard['chrome'] = this.checkNewsCard('chrome');
    this.newsCard['account_voucher'] = this.checkNewsCard('account_voucher');
    this.newsCard['special_promo_voucher'] = this.checkNewsCard('special_promo_voucher');
    this.newsCard['cny_voucher'] = this.checkNewsCard('cny_voucher');
    this.newsCard['account_compare'] = this.checkNewsCard('account_compare');
    this.newsCard['help_center'] = this.checkNewsCard('help_center');
    this.newsCard['referral'] = this.checkNewsCard('referral');
    this.newsCard['platform'] = this.checkNewsCard('platform');
    this.newsCard['account_gift'] = this.checkNewsCard('account_gift');
    this.newsCard['trial_upgrade'] = this.checkNewsCard('trial_upgrade');
    this.newsCard['why_premium'] = this.checkNewsCard('why_premium');
    this.newsCard['setup_venue'] = this.checkNewsCard('setup_venue');
    this.newsCard['invite_couple'] = this.checkNewsCard('invite_couple');
    this.newsCard['migrate_gift'] = this.checkNewsCard('migrate_gift');
    this.newsCard['review'] = this.checkNewsCard('review');
    // this.newsCard['trial'] = this.checkNewsCard('trial');
    this.newsCard['blast_redeem'] = this.checkNewsCard('blast_redeem');
    this.newsCard['blast_intro'] = this.checkNewsCard('blast_intro');
    this.newsCard['theme'] = this.checkNewsCard('theme');
    this.newsCard['blast_notice'] = this.checkNewsCard('blast_notice');
    this.newsCard['whatsapp_launching'] = this.checkNewsCard('whatsapp_launching');
    this.newsCard['web_checkin_launching'] = this.checkNewsCard('web_checkin_launching');
    this.newsCard['guest_web_launching'] = this.checkNewsCard('guest_web_launching');

    this.newsCard['setup_visitor_page'] = this.checkNewsCard('', 'setup_visitor_page');
    this.newsCard['add_guest'] = this.checkNewsCard('', 'add_guest');
    this.newsCard['send_qr'] = this.checkNewsCard('', 'send_qr');
    this.newsCard['invite_member'] = this.checkNewsCard('', 'invite_member');
    this.newsCard['assign_seating'] = this.checkNewsCard('', 'assign_seating');
    this.newsCard['review_setting'] = this.checkNewsCard('', 'review_setting');
    this.newsCard['checkin_guest'] = this.checkNewsCard('', 'checkin_guest');
    this.newsCard['record_gift'] = this.checkNewsCard('', 'record_gift');
  }


  checkNewsCard(newsType?: NewsType, accountTaskType?: AccountTaskType): boolean {
    if (accountTaskType && !this.accountTaskService.checkChecklistPrivilege(accountTaskType)) {
      return false;
    }
    // if (!this.platform.is('hybrid') && this.deviceService.getDeviceBrowser() !== 'chrome') {
    //   if (newsType === 'chrome') {
    //     return true;
    //   }
    // }
    if (!this.guestService.guestList?.length) {
      if (accountTaskType === 'send_qr') {
        return false;
      } else if (accountTaskType === 'assign_seating') {
        return false;
      } else if (accountTaskType === 'checkin_guest') {
        return false;
      } else if (accountTaskType === 'record_gift') {
        return false;
      }
    }
    if (this.newsCardSlideType === 'account_home') {
      if (newsType === 'account_voucher' && !this.getSpecialPromo() && !this.accountInfoService?.accountInfo?.accountStatus?.premium) {
        return true;
      } else if (newsType === 'why_premium') {
        // newsType === 'trial_upgrade' || 
        if (!this.accountInfoService?.accountInfo?.accountStatus?.premium) {
          return true;
        }
      } else if (newsType === 'special_promo_voucher') {
        if (!this.accountInfoService?.accountInfo?.accountStatus?.premium && this.getSpecialPromo(3)) {
          return true;
        }
      } else if (newsType === 'setup_venue') {
        if (!this.accountInfoService?.accountInfo?.location?.name || !this.accountInfoService?.accountInfo?.location?.placeId) {
            return true;
        }
      } else if (newsType === 'invite_couple') {
        // if (this.accountCoupleService?.coupleAccountUserList?.length < 2) {
        //   return true;
        // }
      } else if (newsType === 'referral') {
        // if (this.accountInfoService?.accountInfo?.accountStatus?.premium) {
        //   return true;
        // }
      } else if (newsType === 'migrate_gift') {
        if (this.creditService.getUserMigrateCredit()?.creditId) {
          if (this.accountListSerivce.getOwnMigrateAccount()?.length) {
            return true;
          }
        }
      } else if (accountTaskType === 'setup_visitor_page') {
        // if (this.checkTask(accountTaskType)) {
        //   return true;
        // }
      } else if (accountTaskType === 'add_guest') {
        // return true
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'assign_seating') {
        // return true
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'send_qr') {
        // return true
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'invite_member') {
        // return true
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'review_setting') {
        // return true
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'checkin_guest') {
        // return true
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'record_gift') {
        // return true
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (newsType === 'help_center') {
        return true;
      } else if (newsType === 'platform') {
        // return true;
      } else if (newsType === 'web_checkin_launching') {
        // return true;
      } else if (newsType === 'guest_web_launching') {
        return true;
      }
      //  else if (newsType === 'blast_notice') {
      //   const country = this.getAccountCountry();
      //   if (country === 'US' || country === 'MY' || country === 'SG') {
      //     if (this.checkPrivilege('blast', 'view')) {
      //       return true;
      //     }
      //   }
      // }
    } else if (this.newsCardSlideType === 'account_product') {
      if (newsType === 'account_voucher' && !this.getSpecialPromo()) {
        return true;
      } else if (newsType === 'special_promo_voucher') {
        if (!this.accountInfoService?.accountInfo?.accountStatus?.premium && this.getSpecialPromo(3)) {
          return true;
        }
      }
      // else if (newsType === 'whatsapp_launching') {
      //   return true;
      // }
      //  else if (newsType === 'blast_notice') {
      //   const country = this.getAccountCountry();
      //   if (country === 'US' || country === 'MY' || country === 'SG') {
      //     return true;
      //   }
      // }
      // else if (newsType ===  'account_compare') {
      //   return true;
      // }
    } else if (this.newsCardSlideType === 'promotion') {
      if (newsType === 'account_voucher' && !this.getSpecialPromo()) {
        return true;
      } else if (newsType === 'special_promo_voucher') {
        if (!this.accountInfoService?.accountInfo?.accountStatus?.premium && this.getSpecialPromo(3)) {
          return true;
        }
      }
    } else if (this.newsCardSlideType === 'accounts_add') {
      if (newsType === 'account_voucher' && !this.getSpecialPromo()) {
        return true;
      } else if (newsType === 'special_promo_voucher' ) {
        if (!this.accountInfoService?.accountInfo?.accountStatus?.premium && this.getSpecialPromo(3)) {
          return true;
        }
      } else if (newsType === 'account_gift') {
        return true;
      }
      //  
      // else if (newsType === 'whatsapp_launching') {
      //   return true;
      // }
      // else if (newsType === 'help_center') {
      //   return true;
      // }
    } else if (this.newsCardSlideType === 'support') {
      if (newsType === 'help_center') {
        return true;
      }
      // else if (newsType === 'blast_notice') {
      //   const country = this.getAccountCountry();
      //   if (country === 'US' || country === 'MY' || country === 'SG') {
      //     return true;
      //   }
      // }
      // else if (newsType === 'whatsapp_launching') {
      //   return true;
      // }
    } else if (this.newsCardSlideType === 'guest_home') {
      if (accountTaskType === 'setup_visitor_page') {
        // if (this.checkTask(accountTaskType)) {
        //   return true;
        // }
      } else if (accountTaskType === 'add_guest') {
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'assign_seating') {
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'send_qr') {
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'invite_member') {
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'review_setting') {
        if (this.checkTask(accountTaskType)) {
          return true;
        }
      } else if (newsType === 'help_center') {
        return true;
      } else if (newsType === 'blast_intro') {
        if (this.checkPrivilege('blast', 'view')) {
            return true;
        }
      } else if (newsType === 'web_checkin_launching') {
        // return true;
      } else if (newsType === 'guest_web_launching') {
        return true;
      }
      //  else if (newsType === 'blast_notice') {
      //   const country = this.getAccountCountry();
      //   if (country === 'US' || country === 'MY' || country === 'SG') {
      //     if (this.checkPrivilege('blast', 'view')) {
      //       return true;
      //     }
      //   }
      // }
      //  else if (newsType === 'whatsapp_launching') {
      //   return true;
      // }
    } else if (this.newsCardSlideType === 'guest_qrcode') {
      if (newsType === 'setup_venue') {
        if (!this.accountInfoService?.accountInfo?.location?.name || !this.accountInfoService?.accountInfo?.location?.placeId) {
            return true;
        }
      } else if (accountTaskType === 'setup_visitor_page') {
        // if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        //   return true;
        // }
      } else if (accountTaskType === 'send_qr') {
        if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
          return true;
        }
      } else if (newsType === 'help_center') {
        return true;
      }
    } else if (this.newsCardSlideType === 'checkin_home') {
      if (accountTaskType === 'review_setting') {
        if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
          return true;
        }
      } else if (accountTaskType === 'checkin_guest') {
        if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
          return true;
        }
      } else if (newsType === 'help_center') {
        return true;
      }
    } else if (this.newsCardSlideType === 'gift_home') {
      if (accountTaskType === 'record_gift') {
        if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
          return true;
        }
      } else if (newsType === 'help_center') {
        return true;
      }
    } else if (this.newsCardSlideType === 'accounts_list') {
      if (newsType === 'trial_suggestion') {
        if (!this.accountListSerivce.checkTrialSuggestion()) {
          return true;
        }
      } else if (newsType === 'account_gift') {
        // return true;
      } else if (newsType === 'account_voucher' && !this.getSpecialPromo()) {
        return true;
      } else if (newsType === 'special_promo_voucher') {
        if (!this.accountInfoService?.accountInfo?.accountStatus?.premium && this.getSpecialPromo(3)) {
          return true;
        }
      } else if (newsType === 'help_center') {
        return true;
      } else if (newsType === 'why_premium') {
        return true;
      } else if (newsType === 'platform') {
        // return true;
      } else if (newsType === 'web_checkin_launching') {
        // return true;
      } else if (newsType === 'guest_web_launching') {
        return true;
      }
      //  else if (newsType === 'blast_notice') {
      //   const country = this.getAccountCountry();
      //   if (country === 'US' || country === 'MY' || country === 'SG') {
      //     return true;
      //   }
      // }
      //  else if (newsType === 'whatsapp_launching') {
      //   return true;
      // }
    } else if (this.newsCardSlideType === 'blast_package') {
      if (newsType === 'blast_notice') {
        const country = this.getAccountCountry();
        if (country === 'US' || country === 'MY' || country === 'SG') {
          if (this.checkPrivilege('blast', 'view')) {
            return true;
          }
        }
      } else if (newsType === 'whatsapp_launching') {
        return true;
      }
    } else if (this.newsCardSlideType === 'blast_home') {
      if (newsType === 'blast_notice') {
        const country = this.getAccountCountry();
        if (country === 'US' || country === 'MY' || country === 'SG') {
          if (this.checkPrivilege('blast', 'view')) {
            return true;
          }
        }
      } else if (newsType === 'whatsapp_launching') {
        return true;
      }
    }
    return false;
  }

  output(event: any) {
    this.clickAction.next(event);
  }

  /**
   * Check user privilege
   * @param action Action
   */
  checkPrivilege(module: ModuleType, action: string): boolean {
    return this.privilegeService.checkCurrentUserPrivilege(module, action);
  }

  checkTask(accountTaskType: AccountTaskType) {
    if (accountTaskType === 'setup_visitor_page') {
      if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        return true;
      }
    } else if (accountTaskType === 'add_guest') {
      if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        return true;
      }
    } else if (accountTaskType === 'send_qr') {
      if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        if (this.accountTaskService.checkChecklistStatus('setup_visitor_page') || this.accountTaskService.checkChecklistStatus('add_guest')) {
          return true;
        }
      }
    } else if (accountTaskType === 'invite_member') {
      if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        let count = 0;
        if (this.accountTaskService.checkChecklistStatus('setup_visitor_page')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('add_guest')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('send_qr')) {
          count += 1;
        }
        if (count >= 2) {
          return true;
        }
      }
    } else if (accountTaskType === 'assign_seating') {
      if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        let count = 0;
        if (this.accountTaskService.checkChecklistStatus('setup_visitor_page')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('add_guest')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('send_qr')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('invite_member')) {
          count += 1;
        }
        if (count >= 3) {
          return true;
        }
      }
    } else if (accountTaskType === 'review_setting') {
      if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        let count = 0;
        if (this.accountTaskService.checkChecklistStatus('setup_visitor_page')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('add_guest')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('send_qr')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('invite_member')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('assign_seating')) {
          count += 1;
        }
        if (count >= 4) {
          return true;
        }
      }
    } else if (accountTaskType === 'checkin_guest') {
      if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        let count = 0;
        if (this.accountTaskService.checkChecklistStatus('setup_visitor_page')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('add_guest')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('send_qr')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('invite_member')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('assign_seating')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('review_setting')) {
          count += 1;
        }
        if (count >= 5) {
          return true;
        }
      }
    } else if (accountTaskType === 'record_gift') {
      if (!this.accountTaskService.checkChecklistStatus(accountTaskType)) {
        let count = 0;
        if (this.accountTaskService.checkChecklistStatus('setup_visitor_page')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('add_guest')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('send_qr')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('invite_member')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('assign_seating')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('review_setting')) {
          count += 1;
        }
        if (this.accountTaskService.checkChecklistStatus('checkin_guest')) {
          count += 1;
        }
        if (count >= 6) {
          return true;
        }
      }
    }
    return false;
  }

  async setupSlidePerView(reset?: boolean) {
    await this.functionService.delay(200);
    const width = this.getContainerWidth();
    if (width) {
      const slidePerView = this.getSlidePerView(width);
      if (reset && slidePerView) {
        this.slidePerView = 0;
        // this.ready = false;
        await this.functionService.delay(20);
        // this.ready = true;
      }
      this.slidePerView = slidePerView;
    } else {
      setTimeout(() => {
        this.setupSlidePerView(reset);
      }, 500);
    }
  }

  getSpecialPromo(revertStartDays?: number) {
    let voucherId = this.voucherService.getSpecialPromoVoucher(new Date());
    if (!voucherId && revertStartDays) {
      voucherId = this.voucherService.getSpecialPromoVoucher(new Date(), revertStartDays);
    }
    return voucherId;
  }

  getContainerWidth() {
    return this.container?.nativeElement?.offsetWidth;
  }

  getAccountCountry() {
    return this.localityService.getAccountCountry()?.code;
  }

  getSlidePerView(width?: number) {
    if (!width) {
      width = this.getContainerWidth();
    }
    const maxWidthPerSlide = 482;
    
    let slidePerView = 1;
    if (width > (maxWidthPerSlide * 5)) {
      slidePerView = 5;
    } else if (width > (maxWidthPerSlide * 4.5)) {
      slidePerView = 4.5;
    } else if (width > (maxWidthPerSlide * 3.5)) {
      slidePerView = 3.5;
    } else if (width > (maxWidthPerSlide * 2.5)) {
      slidePerView = 2.5;
    } else if (width > (maxWidthPerSlide * 2)) {
      slidePerView = 2;
    } else if (width > (maxWidthPerSlide * 1.5)) {
      slidePerView = 1.5;
    }

    return slidePerView;
  }

}


